import * as React from 'react';
import { connect } from 'react-redux';
import URLX from '../Url';
import shallowEquals from '../shallow-equals';
import { resolveSyncIfLoadedOrThrow } from '../resolve-component';
function isMountController(component) {
    const controller = component;
    return !!controller.componentShouldRemount;
}
// This class exists as a memoized version of its props. Since props passed to Layout
// can change without the current page changes, we want to avoid re-rendering the
// current page when it hasn't changed.
class CurrentPage extends React.Component {
    constructor(props) {
        super(props);
        this.Component = resolveSyncIfLoadedOrThrow(props.currentPage.componentName, props.currentTheme);
        this.scrollPosition = props.currentPage.scrollPosition;
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.currentPage.componentName !== nextProps.currentPage.componentName ||
            this.props.currentTheme !== nextProps.currentTheme) {
            this.Component = resolveSyncIfLoadedOrThrow(nextProps.currentPage.componentName, nextProps.currentTheme);
        }
        else {
            // We default to always remount if the path of the url changes. So going from /category/product-a to
            // /category/product-b will remount, but going from /category/product-a?i=1 to /category/product-a?i=2
            // will not remount.
            const NextComponent = resolveSyncIfLoadedOrThrow(nextProps.currentPage.componentName, nextProps.currentTheme);
            let shouldRemount = (remountProps, remountNextProps) => remountProps.url !== remountNextProps.url &&
                new URLX(remountProps.url).pathname !== new URLX(remountNextProps.url).pathname;
            if (isMountController(NextComponent)) {
                shouldRemount = NextComponent.componentShouldRemount;
            }
            if (shouldRemount(this.props.currentPage, nextProps.currentPage)) {
                this.Component = (props) => React.createElement(NextComponent, Object.assign({}, props));
            }
        }
        if (this.props.currentPage !== nextProps.currentPage) {
            this.scrollPosition = nextProps.currentPage.scrollPosition;
        }
        else {
            this.scrollPosition = undefined;
        }
    }
    shouldComponentUpdate(newProps) {
        const shouldUpdate = !shallowEquals(this.props, newProps);
        if (!shouldUpdate) {
            console.info('Ignoring update to CurrentPage');
        }
        return shouldUpdate;
    }
    componentDidUpdate() {
        if (this.scrollPosition !== undefined) {
            document.body.scrollTop = this.scrollPosition;
            if (document.documentElement) {
                document.documentElement.scrollTop = this.scrollPosition;
            }
        }
    }
    render() {
        return React.createElement(this.Component, Object.assign({}, this.props.currentPage));
    }
}
export default connect((state) => ({
    currentTheme: state.currentTheme,
    currentPage: state.currentPage,
}))(CurrentPage);
